var n=function(n){return n.FULL="full",n.END="end",n}({});export{n as PageTabsBorder};
//# sourceMappingURL=PageTabs.props.js.map
